// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"929":"bdd82302","985":"7871a6ff"}[chunkId] + ".chunk.css";
};